module.exports = __webpack_public_path__ + "images/ds-landing-bi-instructor-jeff-li.webp";